// extracted by mini-css-extract-plugin
export default {"item":"style_item__sXHzS","gears":"style_gears__ireR6","bottomLabel":"style_bottomLabel__X7ehQ","input":"style_input__z0Dk3"};